import React, { Fragment } from 'react';
import { Button } from '@cmsgov/design-system';
import { FormattedMessage, useIntl } from 'react-intl';

// Components

import ModalHeader from '@components/common/headers/ModalHeader';

const RemoveIncomeOrDeductionSourceModal = props => {

    const intl = useIntl();

    const {
        actions: {
            hideModal
        },
        bottomAnchors: [
            anchor_1
        ],
        boundAnchor,
        modal: {
            modalData: {
                onContinue,
                sourceTypeKey
            }
        },
        modalHeaderProps,
        modalHeaderProps: {
            modalId
        }
    } = props;

    const sourceTypeWord = intl.formatMessage({
        id: `modals.remove_income_deduction_source.type.${sourceTypeKey}`
    });

    const handleContinue = () => {
        onContinue();
        hideModal();
    };

    return (
        <Fragment>
            <div className='gi-modal__header__head'>
                <ModalHeader {...modalHeaderProps} />
            </div>
            <div id='removeIncomeOrDeductionSourceModal' className='gi-modal__body'>
                <p data-testid={`${modalId}_body`}>
                    <FormattedMessage
                        id='modals.remove_income_deduction_source.body'
                        values={{
                            sourceType: sourceTypeWord
                        }}
                    />
                </p>
            </div>
            <div className='gi-modal__footer'>
                <div className='grid-row controls'>
                    <div className='grid-offset-4 txt-left'>
                        <Button
                            className='usa-button gi-button gi-button__primary'
                            data-testid={`${modalId}-go_back_btn`}
                            onClick={hideModal}
                            inputRef={boundAnchor(anchor_1)}
                        >
                            <FormattedMessage id='button.go_back'/>
                        </Button>
                        <Button
                            className='usa-button usa-button--outline gi-button gi-button__outline'
                            data-testid={`${modalId}-continue_btn`}
                            onClick={handleContinue}
                        >
                            <FormattedMessage id='button.continue'/>
                        </Button>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default RemoveIncomeOrDeductionSourceModal;
